import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RekapAbsenGuru = ({ token }) => {
  const [bulan, setBulan] = useState(new Date().toISOString().slice(0, 7)); // YYYY-MM
  const [dataGuru, setDataGuru] = useState([]);

  const handleCari = async () => {
    try {
      const res = await axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/absen-guru`, {
        params: { bulan },
        headers: { Authorization: `Bearer ${token}` }
      });
      setDataGuru(res.data);
    } catch (err) { alert('Gagal memuat data guru'); }
  };

  useEffect(() => { handleCari(); }, []);

  // Format Tanggal
  const formatTanggal = (isoDate) => {
      const date = new Date(isoDate);
      return date.toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <div className="no-print" style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#1e293b' }}>👨‍🏫 Laporan Kehadiran Guru</h2>
        <div style={{ display: 'flex', gap: '10px', background: 'white', padding: '15px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
            <input type="month" value={bulan} onChange={e => setBulan(e.target.value)} style={{ padding: '8px', borderRadius: '6px' }} />
            <button onClick={handleCari} style={{ background: '#4361ee', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>Tampilkan</button>
            <button onClick={() => window.print()} style={{ background: '#334155', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>🖨️ Cetak PDF</button>
        </div>
      </div>

      <div className="print-area" style={{ background: 'white', padding: '30px', borderRadius: '10px' }}>
          <div style={{ textAlign: 'center', marginBottom: '20px', borderBottom: '2px solid #000' }}>
              <h3>LAPORAN KEHADIRAN GURU & STAFF</h3>
              <p>Periode: <b>{bulan}</b></p>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }} border="1">
              <thead>
                  <tr style={{ background: '#f1f5f9' }}>
                      <th style={{ padding: '10px' }}>No</th>
                      <th style={{ padding: '10px' }}>Tanggal</th>
                      <th style={{ padding: '10px' }}>Nama Guru / Staff</th>
                      <th style={{ padding: '10px' }}>NIP</th>
                      <th style={{ padding: '10px' }}>Jam Masuk</th>
                      <th style={{ padding: '10px' }}>Status</th>
                      <th style={{ padding: '10px' }}>Keterangan</th>
                  </tr>
              </thead>
              <tbody>
                  {dataGuru.length === 0 ? (
                      <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>Tidak ada data kehadiran guru bulan ini.</td></tr>
                  ) : (
                      dataGuru.map((d, idx) => (
                          <tr key={idx}>
                              <td style={{ textAlign: 'center', padding: '5px' }}>{idx + 1}</td>
                              <td style={{ padding: '5px' }}>{formatTanggal(d.tanggal)}</td>
                              <td style={{ padding: '5px', fontWeight:'bold' }}>{d.nama}</td>
                              <td style={{ padding: '5px' }}>{d.nip}</td>
                              <td style={{ textAlign: 'center', padding: '5px' }}>{d.jam_masuk}</td>
                              <td style={{ textAlign: 'center', padding: '5px', textTransform:'uppercase' }}>
                                  <span style={{ 
                                      padding:'2px 6px', borderRadius:'4px', fontSize:'11px', fontWeight:'bold', color:'white',
                                      background: d.status === 'hadir' ? '#16a34a' : d.status === 'sakit' ? '#ca8a04' : '#dc2626'
                                  }}>
                                      {d.status}
                                  </span>
                              </td>
                              <td style={{ padding: '5px' }}>{d.keterangan || '-'}</td>
                          </tr>
                      ))
                  )}
              </tbody>
          </table>
          
          <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ textAlign: 'center', width: '200px' }}>
                  <p>Kepala Sekolah,</p>
                  <br/><br/><br/>
                  <p>( __________________ )</p>
              </div>
          </div>
      </div>
    </div>
  );
};

export default RekapAbsenGuru;